// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"168":"d9dd0cde","200":"c85804f6","388":"fc9a1481","898":"3f2ab88e"}[chunkId] + ".chunk.css";
};